var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1889 0L7.80459 6.35387L12.5217 8.09195L7.80459 10.2808L6.1889 16L4.57321 10.2808L0 8.09195L4.57321 6.35387L6.1889 0Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.802 0.695602L12.3406 2.62939L13.913 3.15837L12.3406 3.82453L11.802 5.56517L11.2635 3.82453L9.73906 3.15837L11.2635 2.62939L11.802 0.695602Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8895 9.73915L14.4281 11.6729L16.0005 12.2019L14.4281 12.8681L13.8895 14.6087L13.351 12.8681L11.8266 12.2019L13.351 11.6729L13.8895 9.73915Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.538df240d0f8d7474eefc65f9b2eefbc.svg";
export { ForwardRef as ReactComponent };